import type { QuerySsosArgs, Sso } from '@tribeplatform/gql-client/types'

import {
  useQuery,
  type UseQueryOptions,
} from '../../lib/react-query/useQuery.js'
import { useTribeClient } from '../../useTribeClient.js'
import { getSsosKey } from '../../utils/keys/authToken.keys.js'

export const useSsos = (options?: {
  variables: QuerySsosArgs
  useQueryOptions?: UseQueryOptions<Sso[]>
}) => {
  const { variables, useQueryOptions } = options || {}
  const { client } = useTribeClient()
  const ssosKey = getSsosKey({ variables })

  return useQuery<Sso[]>(
    ssosKey,
    () => client.auth.ssos(variables),
    useQueryOptions,
  )
}
